export default defineNuxtRouteMiddleware((to, from) => {
  const infoRegExp = /^\/info\/(news|guide|policy)\/(.+)/;
  if (infoRegExp.test(to.path)) {
    const [ , prefix, articleId ] = infoRegExp.exec(to.path)!;
    if (articleId && /[/+=]/.test(articleId)) {
      return navigateTo(`/info/${prefix}/${encodeURIComponent(articleId)}`, { replace: true, redirectCode: 301 });
    }
  }
});
